var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner",class:{ 'loading-spinner--overlay': _vm.overlay }},[_c('div',{staticClass:"loading-spinner__content"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}}),(_vm.message)?_c('div',{staticClass:"loading-spinner__message mt-2"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }